import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql';
import { PAGE_TREE_STATUSES } from '@confluence/page-tree/entry-points/pageTreeStatuses';
import { preloadPageTree } from '@confluence/page-tree/entry-points/preloadPageTree';

import DatabaseContainerQuery, {
	type DatabaseContainerQuery$data as DatabaseContainerQueryType,
	type DatabaseContainerQuery$variables as DatabaseContainerQueryVariables,
} from './__generated__/DatabaseContainerQuery.graphql';

export async function preloadDatabaseData(spaceKey: string, contentId: string): Promise<any> {
	return waitForAllReturnWhenError([
		preloadContentData(contentId, spaceKey),
		preloadContentTree(contentId, spaceKey),
	]);
}

async function preloadContentData(contentId: string, spaceKey: string): Promise<void> {
	await query<DatabaseContainerQueryType, DatabaseContainerQueryVariables>({
		query: DatabaseContainerQuery,
		variables: {
			contentId,
			spaceKey,
			// The DSP query doesn't currently user the content version value, so using a fixed value
			contentVersion: 1,
		},
	});
}

async function preloadContentTree(contentId: string, spaceKey: string): Promise<void> {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR && contentId) {
		await preloadPageTree({
			spaceKey,
			statuses: PAGE_TREE_STATUSES,
			isSuperAdmin: false,
			contentId,
		});
	}
}
